import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class CopyKundorderCommand extends BasicCommand<CopyKundorderCommand> {
    get primaryKey(): IPrimaryKey<CopyKundorderCommand> {
        return {
            kundorderId: this.kundorderId
        };
    }
    kundorderId: number;
    periodFrom: Date;
    periodTom: Date;
    kundorderrader: number[];
    kundordertyp: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "kundorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CopyKundorderCommand";
    constructor(init: (instance: CopyKundorderCommand) => void) {
        super(CopyKundorderCommand.$type, CopyKundorderCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
